import { render, staticRenderFns } from "./CouponShow.vue?vue&type=template&id=09b8c38c&"
import script from "./CouponShow.vue?vue&type=script&lang=js&"
export * from "./CouponShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports